<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="Product"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/Product/CoreProductDetail"
        :parent-component="$options.name"
        :main-validator="true"
    >
      <template v-slot:item.notion_id="{ item }">
        <v-icon
            v-if="item.notion_id != null"
            color="primary"
            size="20"
            @click="onNotion(item)"
        >
          mdi-alpha-n-box-outline
        </v-icon>
      </template>
      <template v-slot:item.project_customer__customer__name="{ item }">
        <span
            v-if="!!item.project_customer_uid && storeAggregate.rootData &&
            !!storeAggregate.rootData[item.project_customer_uid].customer_uid &&
            !!storeAggregate.rootData[storeAggregate.rootData[item.project_customer_uid].customer_uid]">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.project_customer_uid].customer_uid].name }}
        </span>
      </template>
      <template v-slot:item.project_customer__name="{ item }">
        <span v-if="!!item.project_customer_uid && storeAggregate.rootData">
          {{ storeAggregate.rootData[item.project_customer_uid].name }}
        </span>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreProductDetail from "@/components/CoreComponent/Product/CoreProductDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";

export default {
  name: "CoreProductTable",

  props: {
    embedded: {default: false},
    storeName: {type: [String], default: 'CoreProductTable'},
    dtoDetailQuery: {default: 'ProductDetailQueryDTO'},
    detailStoreName: {default: 'ProductDetail'},
    dtoValidateCommand: {type: [String], default: 'ProductValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'ProductListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'ProductActionCommandDTO'},
    // dtoSaveCommand: {type: [String], default: 'SimpleSaveCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CoreProductDetail,
    BaseFieldCheck,
  },

  methods: {
    onNotion(item) {
      window.open('https://www.notion.so/' + item.notion_id.replace(/-/g, ''), '_blank')
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = [
      {text: 'T', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 25},
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'N', value: 'notion_id', sortable: true, filterable: true, divider: true, width: 30},
      {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true},
      {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, width: 100},
      {
        text: 'Has new media',
        value: 'has_new_media',
        sortable: true,
        filterable: true,
        divider: true,
        width: 100,
        type: 'bool'
      },
      {text: 'Article number', value: 'article_number', sortable: true, filterable: true, divider: true},
      {text: 'Project', value: 'project_customer__name', sortable: true, filterable: true, divider: true},
      {text: 'Customer', value: 'project_customer__customer__name', sortable: true, filterable: true, divider: true},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      // this.storeTable.dtoSaveCommand = this.dtoSaveCommand
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>